import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down2",
  "use": "icon-down2-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down2\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.49991 8.57906L3.79286 4.34244L3.04028 5.00095L7.12362 9.66761L7.49991 10.0977L7.87619 9.66761L11.9595 5.00095L11.207 4.34244L7.49991 8.57906Z\" fill=\"#C1C1C1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol